import React, { useState, useEffect } from 'react';
import './AuthModal.css';

function AuthModal({ mode, onAuth, onSwitchMode }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (email && password && (mode === 'login' || name)) {
      setLoading(true);
      try {
        await onAuth(email, password, mode, name);
      } catch (err) {
        setError(err.message || 'Authentication failed. Please try again.');
      } finally {
        setLoading(false);
      }
    }
  };

  const isSignup = mode === 'signup';

  return (
    <div className={`auth-modal auth-modal--centered ${isVisible ? 'auth-modal--visible' : ''}`}>
      <div className="auth-modal__content">
        <div className="auth-modal__header">
          <div className="auth-modal__brand">
            <h1 className="auth-modal__brand-title">Remori</h1>
            <p className="auth-modal__brand-tagline">A return to memory</p>
          </div>
          <h2 className="auth-modal__title">
            {isSignup ? 'Create your account' : 'Welcome back'}
          </h2>
          <p className="auth-modal__subtitle">
            {isSignup 
              ? 'Begin your journey of reflection' 
              : 'Continue where you left off'}
          </p>
        </div>

        {error && (
          <div className="auth-modal__error">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <span>{error}</span>
          </div>
        )}

        <form className="auth-modal__form" onSubmit={handleSubmit}>
          {isSignup && (
            <div className="auth-modal__field">
              <label htmlFor="name" className="auth-modal__label">
                Name
              </label>
              <input
                type="text"
                id="name"
                className="auth-modal__input"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required={isSignup}
                autoComplete="name"
              />
            </div>
          )}

          <div className="auth-modal__field">
            <label htmlFor="email" className="auth-modal__label">
              Email
            </label>
            <input
              type="email"
              id="email"
              className="auth-modal__input"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="auth-modal__field">
            <label htmlFor="password" className="auth-modal__label">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="auth-modal__input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete={isSignup ? 'new-password' : 'current-password'}
            />
            {isSignup && (
              <p className="auth-modal__hint">
                Minimum 8 characters, include uppercase, lowercase, and number
              </p>
            )}
          </div>

          <button 
            type="submit" 
            className="auth-modal__submit"
            disabled={loading}
          >
            {loading ? (
              <span className="auth-modal__loading">
                <span className="auth-modal__spinner"></span>
                {isSignup ? 'Creating account...' : 'Logging in...'}
              </span>
            ) : (
              isSignup ? 'Create account' : 'Log in'
            )}
          </button>
        </form>

        <div className="auth-modal__switch">
          <p className="auth-modal__switch-text">
            {isSignup ? 'Already have an account?' : "Don't have an account?"}
          </p>
          <button 
            className="auth-modal__switch-button"
            onClick={onSwitchMode}
            disabled={loading}
          >
            {isSignup ? 'Log in' : 'Create account'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
